<template>
  <form class="form-create-discount-card__form" v-on:submit.prevent="submit">
    <div>
      <span class="form-create-discount-card__title-number">
        Новая {{ discountCard.typeName }}
      </span>
      <label class="form-create-discount-card__field-number">
        <span>№</span>
        <input
          v-model="discountCard.number"
          class="form-create-discount-card__input"
          name="card-number"
          type="number"
        >
      </label>
      <p
        v-for="violationText in cardNumberErrors"
        v-bind:key="violationText"
        class="form-create-discount-card__violation"
        role="alert"
      >{{ violationText }}</p>
    </div>
    <button class="form-create-discount-card__button-submit" type="submit">Выпустить</button>
  </form>
</template>

<script>
import { DiscountCard } from '@/mixins/loyaltySystemMixin';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.violations ? vm.violations[cause] : []
);

/**
 * @description Текст кнопки помощи.
 * @type {string}
 */
const helpText = 'Укажите количество бонусов, начисленных ранее';

export default {
  /**
   * @description Форма создания скидочной карты
   */
  name: 'FormCreateDiscountCard',
  computed: {
    /**
     * @description Скидочная карта
     * @type {DiscountCard}
     */
    discountCard: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    /**
     * @description Ошибки номера карты
     * @type {Array}
     */
    cardNumberErrors: resolveInputErrors('discount_card.card-number'),
  },
  data() {
    return {
      isNumberFieldFocused: false,
    };
  },
  methods: {
    /**
     * @description Отправить форму
     * @returns {void}
     */
    submit() {
      this.$emit('submit');
    },
  },
  props: {
    value: {
      type: DiscountCard,
      required: true,
    },
    /**
     * @description Нарушения
     * @type {Object}
     */
    violations: {
      type: Object,
      required: true,
    },
  },
  helpText,
};
</script>

<style lang="scss" scoped>
@use "@/scss/buttons";

.form-create-discount-card {
  &__form {
    display: grid;
    row-gap: 25px;
    margin: 25px 0;
  }
  &__title-number {
    font-size: 24px;
    color: #1b232d;
    font-weight: bold;
  }
  &__field-number {
    font-size: 24px;
    font-weight: bold;
    color: var(--action-color);
    white-space: nowrap;
  }
  &__input {
    max-width: 120px;
    padding: 5px;
    padding-left: 0;
    font-size: 24px;
    font-weight: bold;
    color: var(--action-color);
    border: 1px solid transparent;
    border-radius: 4px;
    &:focus-visible {
      padding-left: 5px;
      border-color: var(--action-color);
      outline: 0;
    }
  }
  &__violation {
    color: var(--warning-color);
    font-size: 12px;
    line-height: 14px;
    font-weight: 400;
    padding: .125rem;
  }
  &__button-submit {
    @include buttons.btn-blue(100%, 48px, 16px);
  }
}

</style>
